import React, { useState, useEffect, Suspense } from 'react'
import lazyWithRetry from '../../utils/lazyWithRetry'
import '../../styles/analytics/AnalyticsHome.css'

import 'react-datepicker/dist/react-datepicker.css'
import { getAllStudentsTarget, getAnalyticsContent, getAnalyticsHowDoYouFillStats, loadPrimaryStudents, removeContentFromTrendsAsync } from '../../server/server'
import { useUser } from '../../auth/index'
import TargetGroupModal from '../modals/TargetGroupModal'
import { ReactComponent as Collapsedlogo } from '../../assets/svg/US-collapsed.svg'
import { ReactComponent as CollapsedEarlylogo } from '../../assets/svg/US-Early-collapsed.svg'
// import { t } from 'i18next';
import { notify, usePageTitle } from '../../utils/util'
import { useUrlState } from '../../hooks/useUrlState'
import { Link, useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { useTranslation } from 'react-i18next'
import { useAppContext } from '../../context/AppContext'
import AnalyticsHeaderSkeleton from './skeleton/AnalyticsHeaderSkeleton'
import AnalyticsDataLeftSkeleton from './skeleton/AnalyticsDataLeftSkeleton'
import AnalyticsDataRightSkeleton from './skeleton/AnalyticsDataRightSkeleton'

const AnalyticsHeader = lazyWithRetry(() => import('./AnalyticsHeader'), './AnalyticsHeader')

const AnalyticsDataLeft = lazyWithRetry(() => import('./AnalyticsDataLeft'), './AnalyticsDataLeft')

const AnalyticsDataRight = lazyWithRetry(() => import('./AnalyticsDataRight'), './AnalyticsDataRight')

function AnalyticsHome() {
    usePageTitle('Upstrive Education - Analytics')
    const { t, locale } = useTranslation()
    const history = useHistory()
    const { user } = useUser()
    const { appState } = useAppContext()
    const [loading, setLoading] = useState(false)
    const [contentList, setContentList] = useState([])
    const [searchText, setSearchText] = useUrlState('search', '', { debounce: 500 })
    const primaryUI = !!appState?.primary

    useEffect(() => {
        checkUser()
    }, [])

    const checkUser = () => {
        if (!!user.hasOnlyPrimaryStudents) {
            history.replace(`analytics/data?type=data&content=how-do-you-feel&primary=true`)
        }
    }

    useEffect(() => {
        loadContent(0)
    }, [searchText])

    const loadContent = async (number = contentList.length) => {
        setLoading(true)
        const institution_id = user.institution_id
        const data = {
            institution_id: institution_id,
            text: searchText,
        }
        const resp = await getAnalyticsContent(data)
        if (resp.status === 200) {
            const resp_data = resp.data
            const list = resp_data.list.filter((e) => e.type !== 'feedback')
            const previousList = number === 0 ? [] : contentList
            setContentList([...previousList, ...list])
        } else {
            setContentList([])
        }
        setLoading(false)
    }

    const removeContentFromTrends = async (content) => {
        const resp = await removeContentFromTrendsAsync(content.id)
        if (resp.status === 200) {
            notify(t('Content has been removed from trends'))
            loadContent(0)
        }
    }

    return (
        <div id="basic-student" className="analytics-container  light-small-scroll ">
            <div className="analytics-inner-container mb-[40px] ">
                {!!user?.hasPrimaryClasses && !user.hasOnlyPrimaryStudents && !primaryUI && (
                    <div className="flex flex-row gap-[20px] mb-[38px] items-center">
                        <p className="text-[#9392AD] font-semibold text-[18xp]">{t('Display')}: </p>
                        <div className="flex flex-row bg-[#FFFFFF] rounded-full ">
                            {/* This screen is the Education (regular) view, so its side of the
                                toggle is always the active one; Early navigates away. */}
                            <Link to={`/analytics`} className="h-[50px] flex items-center justify-center">
                                <button className="h-[50px] px-[25px] rounded-full justify-center items-center font-bold bg-[#5E639B] text-[#FDDF6D]" disabled>
                                    <Collapsedlogo height={30} />
                                </button>
                            </Link>
                            <Link to={`analytics/data?type=data&content=how-do-you-feel&primary=true`} className="h-[50px] flex items-center justify-center">
                                <button className="h-[50px] px-[25px] rounded-full justify-center items-center font-bold text-[#9392AD]">
                                    <CollapsedEarlylogo height={30} className="collapsed-early-app-icon-not-selected" />
                                </button>
                            </Link>
                        </div>
                    </div>
                )}
                <div className="analytics-header">
                    <Suspense fallback={<AnalyticsHeaderSkeleton />}>
                        <AnalyticsHeader title={t('analytics')} subtitle={t('getDeeperInsights')} />
                    </Suspense>
                </div>
                <div className="w-full h-full flex flex-row justify-center gap-10 mt-5">
                    <Suspense fallback={<AnalyticsDataLeftSkeleton />}>
                        <AnalyticsDataLeft
                            setSearchText={setSearchText}
                            searchText={searchText}
                            contentList={contentList}
                            removeContentFromTrends={removeContentFromTrends}
                        />
                    </Suspense>
                    <Suspense fallback={<AnalyticsDataRightSkeleton />}>
                        <AnalyticsDataRight />
                    </Suspense>
                </div>
            </div>
        </div>
    )
}

export default AnalyticsHome
